module.exports = __webpack_public_path__ + "static/media/photo_022.852fc500.JPG";